export var listItem = function listItem(content) {
  return {
    type: 'listItem',
    content: content
  };
};